// src/hooks/useMetaTags.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook for dynamic metadata/analytics updates on route changes
 * 
 * @param {Function} updateCallback Function to run on route change
 */
const useMetaTags = (updateCallback) => {
  const location = useLocation();
  
  useEffect(() => {
    // Run the callback on initial load and route changes
    if (typeof updateCallback === 'function') {
      updateCallback(location);
    }
    
    // Scroll to top on route change
    window.scrollTo(0, 0);
    
    // Track pageviews if you're using analytics
    if (window.gtag) {
      window.gtag('config', 'G-LWQYYFT96H', {
        page_path: location.pathname + location.search
      });
    }
  }, [location, updateCallback]);
  
  return null;
};

export default useMetaTags;